import { createTeleporter } from 'react-teleporter';

export const PopupMenuTeleporter = createTeleporter();

export const ViewTitleBarTeleporter = createTeleporter({
  multiSources: true,
});
